// @ts-nocheck
import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useRole } from '@/contexts/RoleContext';
import { useAuth } from '@/contexts/AuthContext';

const TENANT_ADMIN_ROLES = [
  'rlevents_super_admin',
  'rlevents_tenant_admin',
  'rlevents_tenant_staff',
  'admin',
  'org_admin',
];

export function RequireTenantAdminRole({ children }: { children: ReactNode }) {
  const { user, loading: authLoading } = useAuth();
  const { loading, isSuperAdmin, isTenantAdmin, roles } = useRole();

  if (authLoading || loading) {
    return <div className="p-8 text-center">Loading...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  const hasTenantAccess =
    isSuperAdmin ||
    isTenantAdmin ||
    (Array.isArray(roles) && roles.some((r: string) => TENANT_ADMIN_ROLES.includes(r)));
  if (!hasTenantAccess) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold mb-2">Access denied</h2>
        <p className="text-muted-foreground">This page is for organization admins only.</p>
      </div>
    );
  }
  return <>{children}</>;
}

export default RequireTenantAdminRole;
